class MunicipalitySelect {

    constructor() {
        jQuery('div.municipality').on('change', 'select', this.changeOptionsOfNextField.bind(this))
    }

    changeOptionsOfNextField(event) {
        let options = jQuery(event.target).find('option:selected').data('options');

        let nextSelectField = jQuery(event.delegateTarget).parent().next('.form-group-selectlist').find('select');
        console.log(11, options);
        let html = '<option value="">- Maak een keuze</option>';
        jQuery.each(options,function(it, el) {
            console.log(it,el);
            html += '<option value="'+el.value+'">'+el.label+'</option>';
        })
        console.log(html, jQuery(event.delegateTarget))
        nextSelectField.html(html);
    }
}


export default new MunicipalitySelect;
